import { BrowserModule } from '@angular/platform-browser';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { Configurations } from '../Configuration';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { NavComponent } from './grida/nav/nav.component';
import { CreateComponent } from './grida/create/create.component';
import { ListComponent } from './grida/list/list.component';
import { DetailComponent } from './grida/detail/detail.component';
import { DescComponent } from './grida/desc/desc.component';
import { MaterialModule } from '../modules/material.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AgreeComponent } from './grida/agree/agree.component';
import { SerengetiCommonModule } from '@serengeti/serengeti-common';
import {HttpClientModule} from '@angular/common/http';
import { LoginComponent } from './grida/login/login.component';
import { FooterComponent } from './grida/footer/footer.component';
import { ChatbotComponent } from './grida/chatbot/chatbot.component';

@NgModule({
  declarations: [
    AppComponent,
    NavComponent,
    CreateComponent,
    ListComponent,
    DetailComponent,
    DescComponent,
    AgreeComponent,
    LoginComponent,
    FooterComponent,
    ChatbotComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MaterialModule,
    BrowserAnimationsModule,
    SerengetiCommonModule,
    HttpClientModule
  ],
  providers: [],
  bootstrap: [AppComponent],
  entryComponents: [
    AgreeComponent,
    LoginComponent
  ]
})
export class AppModule { 
  public static environment: Configurations = null;

  constructor (translate: TranslateService, config: Configurations) {
    translate.setDefaultLang('ko-kr');
    translate.use('ko-kr');

    AppModule.environment = config;

  }

  public static forRoot(environment: Configurations): ModuleWithProviders<any> {
    return {
        ngModule: AppModule,
        providers: [
          { provide: Configurations, useValue: environment }
        ]
    };
  }
}
